// Hero Carousel Module
// Tesla-inspired carousel with auto-rotation and dot navigation

function initializeHeroCarousel(carousel) {
  const slides = carousel.querySelectorAll('.hero-slide');
  const dots = carousel.querySelectorAll('.hero-dot');
  
  if (slides.length === 0) return;

  let currentSlide = 0;
  let isAutoRotating = true;
  let autoRotateInterval;
  let isPaused = false;

  // Get autorotation delay from section settings (default 5 seconds)
  const autoRotationDelay = parseInt(carousel.dataset.autorotationDelay) || 5000;

  // Initialize first slide
  showSlide(0);

  // Start auto-rotation
  startAutoRotation();

  // Add click handlers to dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      pauseAutoRotation();
      showSlide(index);
      resumeAutoRotationWithDelay();
    });
  });

  // Pause on hover/focus
  carousel.addEventListener('mouseenter', pauseAutoRotation);
  carousel.addEventListener('mouseleave', resumeAutoRotation);
  carousel.addEventListener('focusin', pauseAutoRotation);
  carousel.addEventListener('focusout', resumeAutoRotation);

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!carousel.matches(':hover')) return;
    
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      pauseAutoRotation();
      showSlide(currentSlide - 1);
      resumeAutoRotationWithDelay();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      pauseAutoRotation();
      showSlide(currentSlide + 1);
      resumeAutoRotationWithDelay();
    }
  });

  // Touch/swipe support
  let touchStartX = 0;
  let touchEndX = 0;

  carousel.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    pauseAutoRotation();
  });

  carousel.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
    resumeAutoRotationWithDelay();
  });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        showSlide(currentSlide + 1);
      } else {
        // Swipe right - previous slide
        showSlide(currentSlide - 1);
      }
    }
  }

  function showSlide(index) {
    // Handle wrap-around
    if (index >= slides.length) {
      currentSlide = 0;
    } else if (index < 0) {
      currentSlide = slides.length - 1;
    } else {
      currentSlide = index;
    }

    // Update slides
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === currentSlide);
    });

    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === currentSlide);
    });

    // Trigger scroll event for any parallax effects
    window.dispatchEvent(new Event('scroll'));
  }

  function startAutoRotation() {
    if (!isAutoRotating) return;
    
    autoRotateInterval = setInterval(() => {
      if (!isPaused) {
        showSlide(currentSlide + 1);
      }
    }, autoRotationDelay);
  }

  function pauseAutoRotation() {
    isPaused = true;
    clearInterval(autoRotateInterval);
  }

  function resumeAutoRotation() {
    if (isAutoRotating && isPaused) {
      isPaused = false;
      startAutoRotation();
    }
  }

  function resumeAutoRotationWithDelay() {
    setTimeout(resumeAutoRotation, 3000); // Resume after 3 seconds
  }

  // Intersection Observer for lazy loading and performance
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Load high-quality images when carousel is visible
        const images = entry.target.querySelectorAll('img[data-src]');
        images.forEach(img => {
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
        });
      }
    });
  }, {
    threshold: 0.1
  });

  observer.observe(carousel);

  // Preload next/previous images for smooth transitions
  function preloadAdjacentImages() {
    const nextIndex = (currentSlide + 1) % slides.length;
    const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
    
    [nextIndex, prevIndex].forEach(index => {
      const slide = slides[index];
      const img = slide.querySelector('img[data-src]');
      if (img && img.dataset.src) {
        const preloadImg = new Image();
        preloadImg.src = img.dataset.src;
      }
    });
  }

  // Preload adjacent images on slide change
  carousel.addEventListener('transitionend', preloadAdjacentImages);

  // Public API
  return {
    next: () => showSlide(currentSlide + 1),
    prev: () => showSlide(currentSlide - 1),
    goTo: (index) => showSlide(index),
    pause: pauseAutoRotation,
    resume: resumeAutoRotation,
    getCurrentSlide: () => currentSlide
  };
}

// Make function available globally
window.initializeHeroCarousel = initializeHeroCarousel; 